const ITEMS = [
  "WHOLE-FOOD FIRST",
  "ZERO UNNECESSARY SUPPLEMENTS",
  "BLOOD-WORK-BACKED SUPPLEMENTATION",
  "ZERO ADDED SUGAR",
  "LOW GLYCAEMIC INDEX",
  "NHCA CERTIFIED DIETITIAN & NUTRITIONIST",
  "200+ CLIENTS COACHED",
  "DAILY WHATSAPP CHECK-INS",
];

function Track({ hidden }) {
  return (
    <ul className="flex items-center gap-10 pr-10 shrink-0" aria-hidden={hidden || undefined}>
      {ITEMS.map((item) => (
        <li key={item} className="flex items-center gap-10 font-mono text-sm uppercase tracking-[0.25em] text-slate-400">
          {item}
          <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" />
        </li>
      ))}
    </ul>
  );
}

export default function Marquee() {
  return (
    <div className="relative border-y border-line bg-panel/60 py-4 overflow-hidden">
      <div className="flex w-max animate-marquee">
        <Track />
        <Track hidden />
      </div>
    </div>
  );
}